import { JS_DAY_KEYS } from "@/lib/constants";

export function computeOpenStatus(hours) {
  if (!hours) return null;
  if (hours.force_closed) {
    return { open: false, kind: "force", note: hours.closing_note || "" };
  }
  const now = new Date();
  const day = hours.days?.[JS_DAY_KEYS[now.getDay()]];
  if (!day || day.closed) return { open: false, kind: "closed_today" };
  const toMin = (t) => {
    const [h, m] = t.split(":").map(Number);
    return h * 60 + m;
  };
  const cur = now.getHours() * 60 + now.getMinutes();
  const closeMin = day.close === "00:00" ? 24 * 60 : toMin(day.close);
  if (cur >= toMin(day.open) && cur < closeMin) {
    return { open: true, kind: "open", time: day.close };
  }
  if (cur < toMin(day.open)) return { open: false, kind: "opens_at", time: day.open };
  return { open: false, kind: "closed_now" };
}

export function statusLabel(t, status) {
  if (!status) return "";
  if (status.kind === "force") return status.note || t.status.force;
  return (t.status[status.kind] || "").replace("{time}", status.time || "");
}
